import { motion } from "framer-motion";

import polasnap from "../asset/projects/polasnap.png";
import Lagoon from "../asset/projects/Lagoon.png";
import zylar from "../asset/projects/zylar.png";
import payforme from "../asset/projects/payforme.png";
import rockiea from "../asset/projects/rockiea.png";
import njs from "../asset/projects/njs.png";
import alabi from "../asset/projects/alabi.png";
import alayo from "../asset/projects/alayo.png";
import renik from "../asset/projects/renik.png";
import oxtech from "../asset/projects/oxtech.png";

const allProjects = [
  {
    title: "Zylar Streetwear",
    type: "Front-End Build",
    description:
      "A bold e-commerce experience designed for modern streetwear brands with attitude.",
    image: zylar,
    stack: "React · Tailwind · Framer Motion · Payment Integration",
    link: "https://zylar.vercel.app/",
  },

  {
    title: "NJS Royale",
    type: "WordPress Build",
    description:
      "A polished website highlighting an event and ceremony hall, its amenities, and a seamless booking flow.",
    image: njs,
    stack: "Elementor · SEO",
    link: "https://njsroyale.com/",
  },

  {
  title: "Renik Energy",
  type: "WooCommerce Build",
  description:
    "A modern e-commerce website for a solar energy brand, designed to showcase products, streamline inquiries, and support online purchases.",
  image: renik,
  stack: "WordPress · WooCommerce · Elementor",
  link: "https://renikenergy.com/",
},

  {
    title: "Oxtech Academy",
    type: "LMS Build",
    description:
      "A comprehensive learning management system featuring course catalogs, interactive lessons, and student progress tracking.",
    image: oxtech,
    stack: "Elementor · SEO",
    link: "https://oxtechacademy.com/",
  },

  {
    title: "Payforme",
    type: "Front-End Landing Page",
    description:
      "A conversion-focused landing page that simplifies international payments for students.",
    image: payforme,
    stack: "React · Tailwind CSS",
    link: "https://payforme.vercel.app/",
  },

  {
    title: "Alayo",
    type: "WordPress Build",
    description:
      "A polished website showcasing a sleepwear brand, its collections, comfort-focused designs, and a seamless shopping experience.",
    image: alayo,
    stack: "Elementor · SEO",
    link: "https://alayothebrand.com/",
  },

  {
    title: "Polaroid Creator",
    type: "Front-End Tool",
    description:
      "An image tool built around visual nostalgia, typography control, and export quality.",
    image: polasnap,
    stack: "React · Tailwind CSS · html2canvas · jsPDF",
    link: "https://polasnap.vercel.app/",
  },

  {
    title: "ALP",
    type: "WordPress Build",
    description:
      "A professional website highlighting a law firm's services, credibility, and ease of contact.",
    image: alabi,
    stack: "Custom Theme · SEO",
    link: "https://alabilegalpractitioners.com/",
  },

  {
    title: "Lagoon Sports Club",
    type: "Front-End Build",
    description:
      "A dynamic sports club website bringing together articles, events, and monthly highlights.",
    image: Lagoon,
    stack: "React · Tailwind CSS · Framer Motion · remark-gfm",
    link: "https://lsc-three.vercel.app/",
  },

  {
    title: "Rockieafarms",
    type: "WordPress Build",
    description:
      "A commercial website showcasing a pig farm's operations, livestock quality, and supply capacity.",
    image: rockiea,
    stack: "WordPress · Elementor",
    link: "https://rockieafarms.com/",
  },
];

/* PROJECT CARD */

const ProjectItem = ({ project, index }) => (
  <motion.a
    href={project.link}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{
      duration: 0.6,
      delay: index * 0.05,
    }}
    whileHover={{ y: -8 }}
    className="
      group
      relative
      block
      overflow-hidden
      rounded-[28px]
      border
      border-white/10
      bg-[#1C1C1E]
      transition-all
      duration-500
    "
  >
    {/* IMAGE */}
    <div className="overflow-hidden aspect-[4/3]">
      <img
        src={project.image}
        alt={project.title}
        className="
          h-full
          w-full
          object-cover
          transition-transform
          duration-[1200ms]
          ease-out
          group-hover:scale-105
        "
      />
    </div>

    {/* CONTENT */}
    <div className="p-6">

      <span className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#7C6AE6]">
        {project.type}
      </span>

      <h3 className="mt-3 text-[22px] leading-tight font-semibold text-white">
        {project.title}
      </h3>

      <p className="mt-4 text-[15px] leading-relaxed text-white/60">
        {project.description}
      </p>

      <div className="mt-8 flex items-end justify-between gap-5">

        <span className="text-[11px] leading-relaxed text-white/35">
          {project.stack}
        </span>

        <span
          className="
            relative
            text-sm
            font-medium
            text-[#7C6AE6]
          "
        >
          View

          <span
            className="
              absolute
              left-0
              -bottom-1
              h-[1px]
              w-0
              bg-[#7C6AE6]
              transition-all
              duration-300
              group-hover:w-full
            "
          />
        </span>

      </div>

    </div>
  </motion.a>
);

/* MAIN */

const Projects = () => {
  return (
    <section className="bg-[#171718] border-b-2 border-[#7C6AE6] pt-[140px] pb-[80px]">
      <div className="mx-auto max-w-[1300px] px-6">

        {/* HEADING */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <h2 className="text-[26px] uppercase md:text-[36px] font-medium text-white">
            My Projects
          </h2>

          <p className="mt-3 text-base md:text-lg text-white/40">
            Some cool stuff I've built
          </p>
        </motion.div>

        {/* GRID */}
        <div className="grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-2 md:gap-y-16">
          {allProjects.map((project, i) => (
            <ProjectItem
              key={project.title}
              project={project}
              index={i}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Projects;